import script from "./Shares.vue?vue&type=script&setup=true&lang=js"
export * from "./Shares.vue?vue&type=script&setup=true&lang=js"

import "./Shares.vue?vue&type=style&index=0&id=1b934ce0&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b934ce0"]])

export default __exports__